import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faEnvelope,
  faGlobe,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import Collapse from "antd/lib/collapse";
import { Button } from "../ui";
import Typography from "antd/lib/typography";
import Parser from "html-react-parser";
import styled from "styled-components";

const { Panel } = Collapse;
const { Text } = Typography;

export const CollapseWithButtons = ({ dataLists = [], isRawHtml = false }) => {
  return (
    <CollapseAntd accordion bordered={false} expandIcon={null}>
      {(dataLists || []).map((dataList, index) => (
        <Panel
          key={index}
          header={
            <Button width="100%">
              {dataList.image ? (
                <div className="content-button">
                  <div className="item-icon">
                    <img
                      src={dataList.image}
                      alt={dataList.title}
                      loading="lazy"
                    />
                  </div>
                  <div className="item-text">
                    <Text style={{ width: 300 }} ellipsis>
                      {dataList.title}
                    </Text>
                  </div>
                  <div />
                </div>
              ) : (
                <div className="content-button-no-image">
                  <Text style={{ width: 300 }} ellipsis>
                    {dataList.title}
                  </Text>
                </div>
              )}
            </Button>
          }
          className="site-collapse-custom-panel"
        >
          <div className="content-description">
            {dataList.titleContent ? (
              <h3>{dataList.titleContent}</h3>
            ) : (
              <h3>{dataList.title}</h3>
            )}

            {dataList.scope && (
              <div className="item-scope">
                <strong>Alcance: </strong>
                {typeof dataList.scope === "string" ? (
                  <div className="scope-content">{Parser(dataList.scope)}</div>
                ) : (
                  <span>{dataList.scope}</span>
                )}
              </div>
            )}

            {dataList.alert && <h2>"{dataList.alert}"</h2>}

            {/* Renderizado condicional de beneficios */}
            {dataList.benefits && (
              <div className="benefits-container">
                {isRawHtml ? (
                  // Si es Tacna / API (HTML puro en un string o primer elemento)
                  <div className="raw-benefits">
                    {typeof dataList.benefits === "string"
                      ? Parser(dataList.benefits)
                      : Array.isArray(dataList.benefits) && dataList.benefits[0]
                      ? Parser(dataList.benefits[0])
                      : null}
                  </div>
                ) : (
                  // Si es data estática (Array de ítems)
                  <ul className="list-benefits">
                    {Array.isArray(dataList.benefits) &&
                      dataList.benefits.map((benefit, bIndex) => (
                        <li key={bIndex}>
                          {typeof benefit === "string"
                            ? Parser(benefit)
                            : benefit}
                        </li>
                      ))}
                  </ul>
                )}
              </div>
            )}

            {dataList.phones && dataList.phones.length > 0 && (
              <div className="contact-section">
                {dataList.phones.map((phone, pIndex) => (
                  <div className="item-link" key={`phone-${pIndex}`}>
                    <a href={`tel:${phone}`}>
                      <FontAwesomeIcon icon={faPhone} />
                      {phone}
                    </a>
                  </div>
                ))}
              </div>
            )}

            {dataList.emails && dataList.emails.length > 0 && (
              <div className="contact-section">
                {dataList.emails.map((email, eIndex) => (
                  <div className="item-link" key={`email-${eIndex}`}>
                    <a href={`mailto:${email}`}>
                      <FontAwesomeIcon icon={faEnvelope} />
                      {email}
                    </a>
                  </div>
                ))}
              </div>
            )}

            {dataList.links &&
              dataList.links.map(
                (link, lIndex) =>
                  link.url && (
                    <div className="item-link" key={lIndex}>
                      <a href={link.url} rel="noreferrer" target="_blank">
                        <FontAwesomeIcon
                          icon={link.icon ? link.icon : faGlobe}
                        />
                        {link.text ? link.text : "Visita nuestra página web"}
                      </a>
                    </div>
                  )
              )}

            {dataList.urlFile && (
              <div className="item-link">
                <a
                  href={dataList.urlFile}
                  rel="noreferrer"
                  target="_blank"
                  download="Convenio-solicitud.pdf"
                >
                  <FontAwesomeIcon icon={faDownload} />
                  Descargar Ficha de Solicitud
                </a>
              </div>
            )}

            {dataList.qrCode && (
              <QrContainer>
                <p>Escanea el código QR para registrarte:</p>
                <a href={dataList.qrLink} target="_blank" rel="noreferrer">
                  <img src={dataList.qrCode} alt={`QR ${dataList.title}`} />
                </a>
                {dataList.qrLink && <small>O haz clic en la imagen</small>}
              </QrContainer>
            )}
          </div>
        </Panel>
      ))}
    </CollapseAntd>
  );
};

const CollapseAntd = styled(Collapse)`
  .content-button {
    width: 100%;
    display: grid;
    grid-template-columns: 10% 1fr 10%;
    grid-column-gap: 1.5rem;
    position: relative;
    .item-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      img {
        width: 3rem;
        height: 3rem;
        object-fit: contain;
      }
      .img-default {
        width: 2em;
        height: 2em;
      }
    }
    .item-text {
      display: flex;
      align-items: center;
      justify-content: start;
      text-align: left;
      text-transform: uppercase;
      span {
        text-transform: uppercase;
        max-width: 277px;
        color: ${({ theme }) => theme.colors.white};
      }
    }
  }
  .content-button-no-image {
    span {
      color: ${({ theme }) => theme.colors.white};
    }
  }
  .content-description {
    h3 {
      text-align: center;
      line-height: 2em;
      text-transform: uppercase;
    }
    div {
      .list-benefits {
        list-style: none;
        margin: 0;
        padding: 0;
        font-size: 0.8rem;
        li {
          text-align: justify;
          margin-bottom: 0.5rem;
          font-weight: 500;
          overflow: hidden;

          .rimac {
            margin: auto;
            display: flex;
            justify-content: center;
          }
        }
      }
    }
    .item-link {
      color: dodgerblue;
      text-transform: uppercase;
      text-align: start;
      margin: 1.3rem auto;
      font-size: 1em;
      padding-left: 1em;
      a,
      span {
        display: grid;
        grid-template-columns: 13% 1fr;
        align-items: center;
      }
    }
  }
`;

const QrContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  padding: 1rem;
  border-top: 1px dashed ${({ theme }) => theme.colors.white || "#ccc"};

  p {
    font-weight: bold;
    margin-bottom: 1rem;
    text-transform: uppercase;
    font-size: 0.9rem;
  }

  img {
    width: 180px;
    height: 180px;
    background-color: white;
    padding: 10px;
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease;
    cursor: pointer;

    &:hover {
      transform: scale(1.05);
    }
  }

  small {
    margin-top: 0.8rem;
    color: ${({ theme }) => theme.colors.white};
    opacity: 0.7;
    font-size: 0.7rem;
  }
`;
